import hamsClient from 'modules/hams';

export default async (cartId: string) => {
  const r = await hamsClient.delete(`/1.0/public/order/cart/${cartId}/items`);
  return r.data;
};
